export enum CalculationType {
  NORMAL = 'NORMAL',
  ON_DEMAND = 'ON_DEMAND'
}

export interface PayTypeWithCliRegIds {
  cliRegIds: number[];
  allowLaunchAfterClose: boolean;
  calculationType: CalculationType;
  name: string;
  transId: string;
}

export interface PayType {
  allowLaunchAfterClose: boolean;
  calculationType: CalculationType;
  name: string;
  cliRegId: number;
  transId: string;
  additionalTags?: Map<string, string>;
}

// Used to allow a default 'all' option on context bar select
export type PayTypeSelector = { name: string; transId: string; cliRegIds: number[] } | 'ALL' | string;

export interface PayTypeContextChange {
  name: string;
  transId: string;
  cliRegIds: number[];
  disablePayTypeFilter: boolean;
}

export interface PayTypeTranslation {
  key: string;
  args: {
    payType: string;
  };
}

export interface Link {
  rel: string;
  href: string;
}

export interface PaySerieStatistics {
  id: number;
  paySerieId: number;
  name: string;
  progress: number;
  closingdate: string;
  canBeClosed: boolean;
  lastPayPeriodId: number;
  payPeriodContractsCount: number;
  links: Link[];
}

export interface PaySerieStatisticsWithNames extends PaySerieStatistics {
  names?: string[];
  transId?: string;
}
